export const DEFAULT_STOREFRONT_SECTIONS = [
  {
    id: 'hero',
    type: 'hero',
    eyebrow: 'Launch page',
    title: 'A reader-ready home for your book',
    body: 'Generate a polished storefront with launch copy, front and back cover assets, and a physical book mockup for the hero.',
  },
  {
    id: 'blurb',
    type: 'blurb',
    eyebrow: 'Back cover',
    title: 'A sharper pitch for the shelf',
    body: 'The generated storefront will turn your project notes into a back-cover blurb built for readers, not a generic summary.',
  },
  {
    id: 'audience',
    type: 'audience',
    title: 'Built for the right readers',
    bullets: [
      'Position the story by genre, mood, and stakes.',
      'Show the front cover, back cover, and physical book mockup.',
      'Publish a clean share link when the page is ready.',
    ],
  },
];

export function parseStorefrontSections(raw) {
  if (!raw) return DEFAULT_STOREFRONT_SECTIONS;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : DEFAULT_STOREFRONT_SECTIONS;
  } catch {
    return DEFAULT_STOREFRONT_SECTIONS;
  }
}

export function storefrontToPayload(storefront, fallbackTitle = 'Untitled') {
  return {
    title: storefront?.title || fallbackTitle,
    subtitle: storefront?.subtitle || '',
    tagline: storefront?.tagline || '',
    theme: storefront?.theme || 'editorial',
    coverImageStorageId: storefront?.coverImageStorageId,
    coverImageUrl: storefront?.coverImageUrl || '',
    backCoverImageStorageId: storefront?.backCoverImageStorageId,
    backCoverImageUrl: storefront?.backCoverImageUrl || '',
    bookMockupImageStorageId: storefront?.bookMockupImageStorageId,
    bookMockupImageUrl: storefront?.bookMockupImageUrl || '',
    sections: parseStorefrontSections(storefront?.sectionsJson),
    seoTitle: storefront?.seoTitle || '',
    seoDescription: storefront?.seoDescription || '',
    ctaLabel: storefront?.ctaLabel || 'Preorder coming soon',
    ctaMode: storefront?.ctaMode || 'disabled',
    ctaUrl: storefront?.ctaUrl || '',
  };
}

export function publicStorefrontPath(storefront) {
  if (!storefront?.username || !storefront?.projectSlug || !storefront?.bookSlug) return '';
  return `/${storefront.username}/${storefront.projectSlug}/${storefront.bookSlug}`;
}
